namespace SP {
    export interface DeliveryPrice {
        id: string,
        customerId: string,
        deliveryMethodKey: string,
        originCountry: string,
        destinationCountry: string,
        name: string,
        maxLength: number,
        maxWeight: number,
        maxCircumferenceLength: number,
        price: number,
        oversize: number,
        autoGenerated: number,
        active: number
    }

}